import { createClient } from "@supabase/supabase-js";

export const config = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_KEY,
  supabaseStorageBucket: import.meta.env.VITE_SUPABASE_STORAGE_BUCKET,
  supabaseFlraAttachmentsBucket: import.meta.env
    .VITE_SUPABASE_FLRA_ATTACHMENTS_STORAGE_BUCKET,
  supabaseFormTemplatesAttachmentsBucket: import.meta.env
    .VITE_SUPABASE_FORM_TEMPLATES_ATTACHMENTS_STORAGE_BUCKET
};

export const supabase_gps_tracker = createClient(
  import.meta.env.VITE_GPS_TRACKER_URL,
  import.meta.env.VITE_GPS_TRACKER_SERVICE_KEY
);

export const supabase = createClient(
  config.supabaseUrl,
  config.supabaseAnonKey,
  {
    auth: {
      persistSession: true
    }
  }
);
